<div class="card-contact" [ngClass]="{ aBordure: aBordure }">
  <figure class="container-image">
    <img
      src="{{ 'assets/images/click-to-call/icone-appel.svg' | cheminAbsoluStatique }}"
      alt=""
      width="127"
      height="85"
    />
  </figure>
  <span class="separator"></span>
  <div class="content">
    <ng-content select="h4.title"></ng-content>
    <ng-content select="p.texte"></ng-content>
    <ng-content select="div.telephone"></ng-content>
    <div class="container-horaires">
      <ng-content select="p.horaires"></ng-content>
    </div>
  </div>
</div>
